import React from "react";
import "./Hero.css";
import Figma from "../../assests/Figmaicon.png";
import REACTICON from "../../assests/React.png";
import HELLO from "../../assests/hello.png";
import { motion } from "framer-motion";
import Tilt from "react-parallax-tilt";
const Hero = () => {
  return (
    <main className="hero" id="home">
      <motion.div
        initial={{
          opacity: 0,
          scale: 0,
        }}
        animate={{
          opacity: 1,
          scale: 1,
        }}
        transition={{
          duration: 0.6,
          type: "tween",
          stiffness: 120,
          bounce: 0.5,
        }}
        className="name-container"
      >
        <div className="icon">
          <img src={HELLO} alt="" />
        </div>
        <div className="name">
          <h6>Hello I'm</h6>
          <h1>Prince</h1>
        </div>
      </motion.div>

      <motion.div
        className="container"
        initial={{ opacity: 0, marginBottom: "-100vh" }}
        animate={{ opacity: 1, marginBottom: "10%" }}
        transition={{
          duration: 0.5,
          delay: 0.5,
          type: "spring",
          stiffness: 120,
        }}
      >
        <Tilt className="img-container" tiltMaxAngleX={15} tiltMaxAngleY={15}>
          <img src="./assests/hero21.webp" alt="" loading="lazy" />
          <div className="btn-box">
            <a className="btn-yellow" href="#freelance">
              Let's work
            </a>
            <a
              rel="noreferrer"
              href="./assests/myresumemodern.pdf"
              download="Prince Resume"
              target={"_blank"}
              className="btn-yellow-outline"
            >
              Download CV
            </a>
            
          </div>
        </Tilt>
      </motion.div>

      <motion.div
        initial={{
          opacity: 0,
          scale: 0,
        }}
        animate={{
          opacity: 1,
          scale: 1,
        }}
        transition={{
          duration: 0.6,
          type: "tween",
          stiffness: 120,
          bounce: 0.5,
        }}
        className="skills-container"
      >
        <span>Mern Developer</span>
        <span>Freelancer</span>
        <span>Learner</span>
      </motion.div>
      <motion.div
        initial={{
          opacity: 0,
          scale: 0,
        }}
        animate={{
          opacity: 1,
          scale: 1,
        }}
        transition={{
          duration: 0.6,
          type: "tween",
          stiffness: 120,
          bounce: 0.5,
        }}
        className="icon1"
      >
        <img src={REACTICON} alt="figma" loading="lazy" />
      </motion.div>
      <motion.div
        initial={{
          opacity: 0,
          scale: 0,
        }}
        animate={{
          opacity: 1,
          scale: 1,
        }}
        transition={{
          duration: 0.6,
          type: "tween",
          stiffness: 120,
          bounce: 0.5,
        }}
        className="icon2"
      >
        <img src={Figma} alt="figma" loading="lazy" />
      </motion.div>
    </main>
  );
};

export default Hero;
